import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment/getters/detect_mp'
import { platform } from '@/defines/environment'

const getByUrl = () => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  return query.passport_id || hashQuery.passport_id || ''
}

export const getPassportId = userInfo => {
  switch (true) {
    case platform === 'ios' || platform === 'android':
      return userInfo.passportId ? userInfo.passportId : ''
    case miniProgramEnv.isMiniProgram:
      return getByUrl()
    default:
      return getByUrl() || getCookie('mc_loguser_passport')
  }
}
